import { useTreatmentHistoryDetailContext } from '@context/TreatmentHistoryDetail';
import dayjs from 'dayjs';

import * as styles from './styles';

const PharmacyStatus = () => {
  const {
    treatment,
    makingStatusText,
    makingCompleteAt,
    prescriptionPrice,
    lastPrescriptionPayment
  } = useTreatmentHistoryDetailContext();

  return (
    <div css={styles.container}>
      <div css={styles.column}>
        <div css={styles.title}>조제 상태</div>
        <div css={styles.content}>{makingStatusText}</div>
      </div>
      <div css={styles.column}>
        <div css={styles.title}>약국 정보</div>
        <div css={styles.content}>{treatment?.prescription?.pharmacy?.name}</div>
      </div>
      <div css={styles.column}>
        <div css={styles.title}>조제 시간</div>
        <div css={styles.content}>
          {makingCompleteAt && dayjs(makingCompleteAt).format('YYYY.MM.DD HH:mm')}
        </div>
      </div>
      <div css={styles.column}>
        <div css={styles.title}>조제비</div>
        <div
          css={[
            styles.content,
            lastPrescriptionPayment?.paymentStatus === 'fail' && styles.failed
          ]}
        >
          {lastPrescriptionPayment?.paymentStatus === 'complete' &&
            typeof prescriptionPrice === 'number' &&
            `${prescriptionPrice}원`}
          {lastPrescriptionPayment?.paymentStatus === 'fail' && ' - 결제 실패'}
        </div>
      </div>
    </div>
  );
};

export default PharmacyStatus;
